import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import Dashboard from "../pages/Dashboard";
import SignInPage from "../pages/SignInPage";
import SignUpPage from "../pages/SignUpPage";
import StaffListPage from "../pages/StaffListPage";
import LocationsListPage from "../pages/LocationsListPage";
import StaffCreatePage from "../pages/StaffCreatePage";
import StaffEditPage from "../pages/StaffEditPage";
import BranchList from "../pages/BranchList";
import ClientBranchAddPage from "../pages/ClientBranchAddPage";
import SlotOverviewPage from "../pages/SlotOverviewPage";
import ClientBranchEditPage from "../pages/ClientBranchEditPage";
import LocationsEditPage from "../pages/LocationsEditPage";
import ClientRolesPage from "../pages/ClientRolesPage";
import AddClientRolePage from "../pages/AddClientRolePage";
import ClientRoleEditPage from "../pages/ClientRoleEditPage";
import SlotCreatePage from "../pages/SlotCreatePage";
import SlotEditPage from "../pages/SlotEditPage";
import StaffBranchesPage from "../pages/StaffBranchesPage";
import AddStaffBranchPage from "../pages/AddBranchStaffPage";
import PermissionsPage from "../pages/PermissionPage";
import AddNewPermissionPage from "../pages/AddNewPermissionPage";
import CustomerProfilePage from "../pages/CustomerProfilePage";
import AddCustomerProfilePage from "../pages/AddCustomerProfilePage";
import EditCustomerProfilePage from "../pages/EditCustomerProfilePage";
import StaffDetailPage from "../pages/StaffDetailPage";
import SubscriptionPage from "../pages/SubscriptionPage";
import UserHistoryPage from "../pages/UsageHistoryPage";
import AddBranchLocationPage from "../pages/AddBranchLocationPage";
import ProfilePage from "../pages/ProfilePage";
import PricingModelPage from "../pages/PricingModelPage";
import AccessDeniedPage from "../pages/AccessDeniedPage";
import WorkFlow from "../pages/workflow/WorkFlow";
import WorkFlowEdit from "../pages/workflow/WorkFlowEdit";
import WorkFlowRunning from "../pages/workflow/WorkFlowRunning";
import WorkFlowInstance from "../pages/workflow/WorkFlowInstance";
import WorkFlowAssign from "../pages/workflow/WorkFlowAssign";
import WorkFlowAssignList from "../pages/workflow/WorkFlowAssignList";
import HomePage from "../pages/HomePage";
import PaymentSuccess from "../pages/PaymentSuccess";
import WorkFlowInstanceHistory from "../pages/workflow/WorkFlowInstanceHistory";
import IncentivePlan from "../pages/IncentivePlan";
import IncentiveAssginment from "../pages/IncentiveAssginment";
import AddIncentivePlan from "../pages/AddIncentivePlan";
import EditIncentivePlan from "../pages/EditIncentivePlan";
import AddIncentiveAssginment from "../pages/AddIncentiveAssigmnet";
import MyIncentiveWalletf from "../pages/MyIncentiveWallet";
import RedeemRequestsPage from "../pages/RedeemRequestsPage";
import StaffAttendencePage from "../pages/StaffAttendencePage";
import RevenueReportsPage from "../pages/RevenueReportsPage";
import LandingPage from "../pages/LandingPage";
import BranchesHierarchyPage from "../pages/BranchesHierarchyPage";
import NotificationsPage from "../pages/NotificationsPage";
import UsageStaticticsPaymentSuccess from "../pages/UsageStaticticsPaymentSuccess";
import ReceiptUIPage from "../pages/ReceiptUIPage";
import UsageStaticticsPaymentCancelled from "../pages/UsageStaticticsPaymentCancelled";
import PaymentCancelled from "../pages/PaymentCancelled";
import { useEffect } from "react";

const AppRoutes = () => {
  const PublicLayout = () => {
  useEffect(() => {
    localStorage.setItem("theme", "light");
    document.documentElement.setAttribute('data-theme', "light");
  }, []);

  return <Outlet />; // Isse nested public routes render honge
};

  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
      <Route path="/sign-up" element={<SignUpPage />} />
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route path="/subscription/success" element={<PaymentSuccess />} />
      <Route path="/subscription/cancelled" element={<PaymentCancelled />} />
      <Route path="/billing/success" element={<UsageStaticticsPaymentSuccess />} />
      <Route path="/billing/cancelled" element={<UsageStaticticsPaymentCancelled />} />

      <Route path="/" element={<LandingPage />} />
      </Route>
      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/user-profile" element={<ProfilePage />} />
        <Route path="/receipt" element={<ReceiptUIPage />} />
        {/* Main Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/home" element={<HomePage />} />
        {/* Incentive Plan */}
        <Route path="/incentive-plan" element={<IncentivePlan />} />
        <Route path="/incentive-assginment" element={<IncentiveAssginment />} />
        <Route path="/add-incentive-plan" element={<AddIncentivePlan />} />
        <Route path="/edit-incentive-plan" element={<EditIncentivePlan />} />
        <Route path="/redeem-requestes" element={<RedeemRequestsPage />} />
        <Route path="/staff-attendence" element={<StaffAttendencePage />} />
        <Route path="/revenue-reports" element={<RevenueReportsPage />} />
        <Route path="/branches-hierarchy" element={<BranchesHierarchyPage />} />
        

        <Route
          path="/add-incentive-assgiment"
          element={<AddIncentiveAssginment />}
        />
        <Route path="/my-incentive-wallet" element={<MyIncentiveWalletf />} />
        {/* Staff Roles */}
        <Route path="/staff-roles" element={<ClientRolesPage />} />
        <Route path="/staff-role-create" element={<AddClientRolePage />} />
        <Route path="/staff-role-edit" element={<ClientRoleEditPage />} />
        {/* Staff Management */}
        <Route path="/staff" element={<StaffListPage />} />
        <Route path="/staff-create" element={<StaffCreatePage />} />
        <Route path="/staff-edit" element={<StaffEditPage />} />
        <Route path="/staff-details" element={<StaffDetailPage />} />
        {/* Staff Branch */}
        <Route path="/staff-branches" element={<StaffBranchesPage />} />
        <Route path="/staff-branch-assign" element={<AddStaffBranchPage />} />
        {/* Branch */}
        <Route path="/branch-list" element={<BranchList />} />
        <Route path="/branch-create" element={<ClientBranchAddPage />} />
        <Route path="/branch-edit" element={<ClientBranchEditPage />} />
        {/* Location */}
        <Route path="/branch-locations" element={<LocationsListPage />} />
        <Route
          path="/branch-location-create"
          element={<AddBranchLocationPage />}
        />
        <Route path="/branch-location-edit" element={<LocationsEditPage />} />
        {/* Slots */}
        <Route path="/slots" element={<SlotOverviewPage />} />
        <Route path="/slot-create" element={<SlotCreatePage />} />
        <Route path="/slot-edit" element={<SlotEditPage />} />
        {/* Customer Profile */}
        <Route path="/customer-profiles" element={<CustomerProfilePage />} />
        <Route
          path="/customer-profile-create"
          element={<AddCustomerProfilePage />}
        />
        <Route
          path="/customer-profile-edit"
          element={<EditCustomerProfilePage />}
        />
        {/* Vehicle Pricing */}
        <Route path="/vehicle-pricing" element={<PricingModelPage />} />
        {/* Subscription */}
        <Route path="/subscription" element={<SubscriptionPage />} />
        {/* User History */}
        <Route path="/usage-statistics" element={<UserHistoryPage />} />
        {/* Permissions */}
        <Route path="/permissions" element={<PermissionsPage />} />
        <Route path="/assign-permission" element={<AddNewPermissionPage />} />
        {/* WorkFlow */}
        <Route path="/workflows" element={<WorkFlow />} />
        <Route path="/workflow-edit" element={<WorkFlowEdit />} />
        <Route path="/workflow-assign-list" element={<WorkFlowAssignList />} />
        <Route path="/workflow-assign" element={<WorkFlowAssign />} />
        <Route path="/workflows-running" element={<WorkFlowRunning />} />
        <Route path="/workflow-instances" element={<WorkFlowInstance />} />
        <Route
          path="/workflow-instances-history"
          element={<WorkFlowInstanceHistory />}
        />
      </Route>
      {/* Catch-all route for invalid URLs */}
      <Route path="*" element={<Navigate to="/access-denied" replace />} />
    </Routes>
  );
};

export default AppRoutes;
